import { ChartColors, IMetric } from '@monorepo/base/src/components/chart/chart';
import styles from './metrics-grid.module.scss';
import MetricsCube, { MetricCubeTrend } from './metrics-cube/metrics-cube';
import { PerformanceMetricsSymbols } from '@monorepo/tools/src/lib/enums/performance-labels';
import { IDebugProps } from '@monorepo/tools/src/lib/interfaces/debug';
export interface IGrid {
	metrics: IMetric[];
	compareMetrics?: IMetric[];
	labels: string[];
	isError?: boolean;
	isLoading?: boolean;
	legendOptions?: string[];
	debugProps?: IDebugProps;
}

export const MetricsGrid = (props: IGrid) => {
	const rowMetrics = props.metrics.slice(0, 5);
	const compareMetrics = props.compareMetrics || [];
	// map of duble metrics current + compare
	const matchinMetrics = rowMetrics.map(metric => {
		const cmp = compareMetrics.find(m => m.label === metric.label);
		return [metric, cmp ?? undefined] as [IMetric, IMetric?];
	});

	let i = 0;

	const getFormattedValue = (metric: IMetric) => {
		const formatter = metric?.formatter;
		const symbol = PerformanceMetricsSymbols.get(metric.label as any);
		let formattedValue = formatter ? formatter(metric?.sum || 0, false) : metric.sum || 0;

		if (symbol === '%') {
			formattedValue = ((metric.sum || 0) * 100).toFixed(0) + '%';
		} else if (symbol === '$') {
			formattedValue = '$' + formattedValue;
		}

		return formattedValue ? formattedValue : 'N/A';
	};

	const getMetricDiv = (metrics: [IMetric, IMetric?], index: number) => {
		const currentMetric = metrics[0];
		const compareMetric = metrics[1];
		const currentFormattedValue = getFormattedValue(currentMetric);
		const compareFormattedValue = compareMetric ? getFormattedValue(compareMetric) : undefined;

		const compareTrendSum = compareMetric ? (currentMetric.sum || 0) - (compareMetric.sum || 0) : 0;
		const trend = compareMetric
			? compareTrendSum > 0
				? MetricCubeTrend.RISING
				: compareTrendSum < 0
				? MetricCubeTrend.FALLING
				: MetricCubeTrend.EQUAL
			: undefined;
		const color = ChartColors[i++];
		return (
			<div key={index} className={styles.metricWrapper} style={{ borderColor: color }}>
				<MetricsCube
					label={currentMetric.label}
					value={currentFormattedValue}
					valueSum={currentMetric.sum}
					isLoading={props.isLoading}
					compareValue={compareFormattedValue}
					compareValueSum={compareMetric?.sum}
					compareTrend={trend}
				/>
			</div>
		);
	};

	return (
		<div>
			<div className={styles.gridWrapper}>
				<div className={styles.row}>{matchinMetrics.map((metric, index) => getMetricDiv(metric, index))}</div>
			</div>
		</div>
	);
};
